import {Injectable} from '@angular/core';
import {MaxAnnualIncomeLevelViewModel, PublicClient} from './api.client';

@Injectable({providedIn: 'root'})
export class AnnualIncomeService {
    public maxAnnualUhonsIncomeLevels: MaxAnnualIncomeLevelViewModel[];
    public maxAnnualStlWaterIncomeLevels: MaxAnnualIncomeLevelViewModel[];
    public maxAnnualUFFIncomeLevels: MaxAnnualIncomeLevelViewModel[];

    public hasUhonsIncomeLevelError = false;
    public hasStlWaterIncomeLevelError = false;
    public hasUffIncomeLevelError = false;

    constructor(private publicClient: PublicClient) {
    }

    public getData(): void {
        this.publicClient.getMaxAnnualUhonsIncomes().subscribe({
            next: (response: MaxAnnualIncomeLevelViewModel[]) => {
                this.maxAnnualUhonsIncomeLevels = response;
                this.hasUhonsIncomeLevelError = this.maxAnnualUhonsIncomeLevels?.length < 1;
            },
            error: (err) => {
                console.error(err);
                this.maxAnnualUhonsIncomeLevels = [];
                this.hasUhonsIncomeLevelError = true;
            }
        });

        this.publicClient.getMaxAnnualStlWaterIncomes().subscribe({
            next: (response: MaxAnnualIncomeLevelViewModel[]) => {
                this.maxAnnualStlWaterIncomeLevels = response;
                this.hasStlWaterIncomeLevelError = this.maxAnnualStlWaterIncomeLevels?.length < 1;
            },
            error: (err) => {
                console.error(err);
                this.maxAnnualStlWaterIncomeLevels = [];
                this.hasStlWaterIncomeLevelError = true;
            }
        });

        this.publicClient.getMaxAnnualUfFIncomes().subscribe({
            next: (response: MaxAnnualIncomeLevelViewModel[]) => {
                this.maxAnnualUFFIncomeLevels = response;
                this.hasUffIncomeLevelError = this.maxAnnualUFFIncomeLevels?.length < 1;
            },
            error: (err) => {
                console.error(err);
                this.maxAnnualUFFIncomeLevels = [];
                this.hasUffIncomeLevelError = true;
            }
        });
    }

    private getMaxAnnualUhonsIncomeByHouseholdCount(householdCount: number): number {
        if (!householdCount || householdCount < 1 || !this.maxAnnualUhonsIncomeLevels?.length) {
            return 0;
        }
        const incomeData = this.maxAnnualUhonsIncomeLevels.find(
            (x) => x.householdSize === householdCount
        );
        return incomeData?.maxAnnualIncome || 0;
    }

    public calculatePovertyLevelMaxAnnualUhonsIncomeForHouseholdCount(
        householdCount: number
    ): number {
        if (householdCount < 1) {
            return 0;
        }
        return this.getMaxAnnualUhonsIncomeByHouseholdCount(householdCount);
    }

    private getMaxAnnualStlWaterIncomeByHouseholdCount(householdCount: number): number {
        if (!householdCount || householdCount < 1 || !this.maxAnnualStlWaterIncomeLevels?.length) {
            return 0;
        }
        const incomeData = this.maxAnnualStlWaterIncomeLevels.find(
            (x) => x.householdSize === householdCount
        );
        return incomeData?.maxAnnualIncome || 0;
    }

    public calculatePovertyLevelMaxAnnualStlWaterIncomeForHouseholdCount(
        householdCount: number
    ): number {
        if (householdCount < 1) {
            return 0;
        }
        const temp = this.getMaxAnnualStlWaterIncomeByHouseholdCount(householdCount);
        return temp;
    }

    private getMaxAnnualUFFIncomeByHouseholdCount(householdCount: number): number {
        if (householdCount < 1) {
            return 0;
        }
        const incomeData = this.maxAnnualUFFIncomeLevels.find(
            (x) => x.householdSize === householdCount
        );
        return incomeData?.maxAnnualIncome || 0;
    }

    public calculatePovertyLevelMaxAnnualUFFIncomeForHouseholdCount(
        householdCount: number
    ): number {
        if (householdCount < 1) {
            return 0;
        }
        return this.getMaxAnnualUFFIncomeByHouseholdCount(householdCount);
    }
}
